export var ToggleStateValue;
(function (ToggleStateValue) {
    ToggleStateValue["ON"] = "on";
    ToggleStateValue["OFF"] = "off";
    ToggleStateValue["INDETERMINATE"] = "indeterminate";
})(ToggleStateValue || (ToggleStateValue = {}));
export var ToggleStateStatus;
(function (ToggleStateStatus) {
    ToggleStateStatus["ENABLED"] = "enabled";
    ToggleStateStatus["DISABLED"] = "disabled";
    ToggleStateStatus["READONLY"] = "readonly";
})(ToggleStateStatus || (ToggleStateStatus = {}));
export var ToggleActionType;
(function (ToggleActionType) {
    ToggleActionType["NEXT"] = "next";
    ToggleActionType["ON"] = "on";
    ToggleActionType["OFF"] = "off";
    ToggleActionType["TOGGLE"] = "toggle";
    ToggleActionType["DETERMINATE"] = "determinate";
    ToggleActionType["INDETERMINATE"] = "indeterminate";
    ToggleActionType["READONLY"] = "readonly";
    ToggleActionType["DISABLE"] = "disable";
    ToggleActionType["ENABLE"] = "enable";
})(ToggleActionType || (ToggleActionType = {}));
